import React from 'react'

import type { BulletedListProps } from '@components/ui/BulletedList'
import { BulletedList } from '@components/ui/BulletedList'
import { Collapse } from '@components/ui/CollapseElements'

import type { SimpleContentAccordionControlBaseProps } from './elements'
import { SimpleContentAccordionControl } from './elements'

interface InformationListAccordionProps extends SimpleContentAccordionControlBaseProps, BulletedListProps {
  visibleOnRender?: boolean
  withoutList?: boolean
}

/**
 * Simple listing component with collapse functionality
 *
 * @param {InformationListAccordionProps} {
 *   children,
 *   className,
 *   title,
 *   titleTag = 'h2',
 *   visibleOnRender = true,
 *   withoutList = false,
 * }
 */
export function InformationListAccordion({
  children,
  className,
  title,
  titleTag = 'h2',
  visibleOnRender = true,
  withoutList = false,
}: InformationListAccordionProps) {
  const [isDetailVisible, setDetailVisible] = React.useState(visibleOnRender)

  // wrap every children component into list elements to be DRY
  const controlledChildren = withoutList ? children : <BulletedList>{children}</BulletedList>

  function toggleVisibility() {
    setDetailVisible(state => !state)
  }

  return (
    <>
      <SimpleContentAccordionControl
        className={className}
        title={title}
        titleTag={titleTag}
        isDetailVisible={isDetailVisible}
        toggleVisibility={toggleVisibility}
      />
      <Collapse isExpanded={isDetailVisible}>{controlledChildren}</Collapse>
    </>
  )
}
